import { FC, PropsWithChildren, ReactNode, useEffect, useMemo, useState } from 'react';

export const CarouselItem: FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <div className="carousel-item" style={{ minWidth: '100%' }}>
      <div className="slds-grid slds-grid--vertical-align-center">{children}</div>
    </div>
  );
};

export interface ICarouselProps {
  onChangeItem?: (currentItem: number) => void;
  children: ReactNode[];
  width: number | string;
  autoScroll?: number;
}

export const Carousel: FC<PropsWithChildren<ICarouselProps>> = (props) => {
  const { width, children, onChangeItem, autoScroll } = props;

  const [isScrollDisabled, setIsScrollDisabled] = useState<boolean>(!autoScroll);
  const [currentItem, setCurrentItem] = useState<number>(0);

  // Notify parent of item changes after render completes
  useEffect(() => {
    if (onChangeItem) {
      onChangeItem(currentItem);
    }
  }, [currentItem, onChangeItem]);

  const scrollRight = () => {
    setCurrentItem((item) => {
      return item + 1 > children.length - 1 ? 0 : item + 1;
    });
  };

  const scrollLeft = () => {
    if (!isScrollDisabled) {
      setIsScrollDisabled(true);
    }
    setCurrentItem((item) => {
      return item - 1 < 0 ? children.length - 1 : item - 1;
    });
  };

  const handleClickNext = () => {
    if (!isScrollDisabled) {
      setIsScrollDisabled(true);
    }
    scrollRight();
  };

  const translateX = useMemo(() => {
    return 100 * currentItem;
  }, [currentItem]);

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (autoScroll && autoScroll > 0) {
      timer = setInterval(scrollRight, autoScroll);
    }
    if (timer && isScrollDisabled) {
      clearInterval(timer);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [autoScroll, isScrollDisabled]);

  return (
    <div className="carousel-container">
      <button className="carousel-btn carousel-btn-prev" onClick={scrollLeft}>
        {'<'}
      </button>
      <div className="carousel" style={{ width }}>
        <div className="inner" style={{ transform: `translateX(-${translateX}%)` }}>
          {children}
        </div>
      </div>
      <button className="carousel-btn carousel-btn-next" onClick={handleClickNext}>
        {'>'}
      </button>
    </div>
  );
};

export default Carousel;
